export const fileStatus = {
  UPLOAD: "UPLOAD",
  DOWNLOAD: "DOWNLOAD",
  ERROR: "ERROR",
  OK: "OK",
} as const;

export const DEFAULT_FILE_ICON = "file-icon";
export const fileTypeIcons: Record<string, string> = {
  png: "icon-png",
  jpg: "icon-jpg",
  xls: "icon-xls",
  xlsx: "icon-xlsx",
  ppt: "icon-ppt",
  pptx: "icon-pptx",
  pdf: "icon-pdf",
  csv: "icon-csv",
  html: "icon-html",
  css: "icon-css",
  json: "icon-json",
  xsv: "icon-xsv",
  zip: "icon-zip",
  rar: "icon-rar",
  doc: "icon-doc",
  docx: "icon-docx",
  txt: "icon-txt",
};
